import { render, staticRenderFns } from "./OutboundDispensing.vue?vue&type=template&id=1c82baa2&scoped=true"
import script from "./OutboundDispensing.vue?vue&type=script&lang=js"
export * from "./OutboundDispensing.vue?vue&type=script&lang=js"
import style0 from "./OutboundDispensing.vue?vue&type=style&index=0&id=1c82baa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c82baa2",
  null
  
)

export default component.exports